import { Component, OnInit } from '@angular/core';
import { PROVINCES } from '../../../data/provinces';
import { Supplier } from '../../../../classes/Supplier';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';
import { GlobalService } from '../../../services/global.service';
import { AlertsService } from '../../../services/alerts.service';
import * as $ from 'jquery';

@Component({
  selector: 'app-add-supplier',
  templateUrl: './add-supplier.component.html',
  styleUrls: ['./add-supplier.component.scss']
})
export class AddSupplierComponent implements OnInit {

  provinces = PROVINCES;

  isSubmitButtonDisabled: boolean = false;
  newSupplier: Supplier = new Supplier( );
  addEmailButtonDisabled: boolean = true;
  availableRoles: string[] = [ 'admin', 'installer' ];
  isAvailable: boolean = true;

  selectParams: any = {
    state: {
      id: 'inputState',
      isRequired: true,
      change: ( event ) => {
        this.newSupplier.state = event.value;
      },
      options: [ { text: '', value: '' } ]
    }
  };

  constructor ( 
    private model: ModelService,
    public global: GlobalService,
    private alerts: AlertsService,
    private loginService: LoginService ) { 
    this.global.setDocumentTitle( 'Add Supplier' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;

    this.provinces.forEach( _state => {
      this.selectParams.state.options.push( { text: _state.long, value: _state.short } );
    });
  }

  ngOnInit ( ) { 
  }

  trackByIndex( index: number, obj: any ): any {
    return index;
  }

  addEmail ( ) {
    this.newSupplier.emails.push( '' );
    this.checkEmail( );
  }

  checkEmail ( ) {
    this.addEmailButtonDisabled = ( this.newSupplier.emails.indexOf( '' ) !== -1 ) ? true : false;
  }

  removeEmail ( _i: number ) {
    this.newSupplier.emails.splice( _i, 1 );
    this.checkEmail( );
  }



  successCallback ( ) {
    this.global.defaultSuccessMessage({ 
      html: 'New supplier has been added successfully', 
      redirect: '/suppliers-list' 
    });
  }


  errorCallback ( message?: string ) {
    let data = {
      messageType: 'error',
      message: message || 'We got some error here...',
      title: ''
    }
    this.alerts.setData( data ).subscribe( );
    this.isSubmitButtonDisabled = false;
  }

  submitForm ( ) {

    this.isSubmitButtonDisabled = true;
    this.model.addSupplier( this.newSupplier, ( response ) => {

      let _answer = response.json( ).answer;
      
      if ( _answer == 'success' ) this.successCallback( );
      else if ( _answer == 'exists' ) {
        this.errorCallback( 'Supplier with name "' + this.newSupplier.name + '" already exists' );
        this.global.defaultErrorCallback( 'Supplier with name "' + this.newSupplier.name + '" already exists' );
      } else {
        this.errorCallback( _answer );
        this.global.defaultErrorCallback( _answer );
      }
    });
    return false;
  }

  cancelSubmit ( ) {
    this.global.redirect( '/suppliers-list' );
  }
}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/suppliers/add-supplier/add-supplier.component.ts